module.exports = __webpack_public_path__ + "static/06-d5a5512cd158676dbef7b85af45d36ca.jpg";